module.exports = __webpack_public_path__ + "static/img/s2.7ae84089.png";